module.exports = __webpack_public_path__ + "static/img/samajuri (29).bcca503.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/samajuri/samajuri (29).jpg
// module id = qyjE
// module chunks = 0